import { AnyAction } from 'redux';
import { reducerWrapper } from '../support/utils';
import { FETCH_APP_CATEGORY } from '../actions/AppCategoryActions';
import type { AppCategory as AppCategoryType } from '../../../../shared/types';

export type AppCategoryReducer = {
  loading: boolean;
  error: any;
  category: AppCategoryType['category'] | null;
};

export const INIT_STATE = {
  loading: true,
  error: null,
  category: null,
};

const Handler = (state: AppCategoryReducer, action: AnyAction): AppCategoryReducer => {
  switch (action.type) {
    case FETCH_APP_CATEGORY.response:
      return {
        ...state,
        loading: false,
        category: action.data.data?.category,
      };
    default:
      return state;
  }
};

const AppCategory = reducerWrapper<AppCategoryReducer, AnyAction>(INIT_STATE, Handler, {
  request: [],
  error: [],
});

export default AppCategory;
